import { ApplicationConfig, InjectionToken, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HammerModule } from '@angular/platform-browser';
import { PCPS_DIALOGS_DEFAULT_OPTIONS, PCPSDialogsDefaultOptions } from '@polk_county_public_schools/ngx-pcps-dialogs/core';
import {
    PCPS_SNACK_BAR_DEFAULT_OPTIONS,
    PCPSSnackBarDefaultOptions,
    SnackBarModule,
} from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { MessageBoxDialogModule } from '@polk_county_public_schools/ngx-pcps-dialogs/messagebox';
import { ConfirmationDialogModule } from '@polk_county_public_schools/ngx-pcps-dialogs/confirmation';
import { AuthIntercept } from './interceptor.ng';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SplashService } from '@polk_county_public_schools/ngx-pcps-dialogs/splash';
import { provideQuillConfig, QuillModule } from 'ngx-quill';

export function getBaseUrl(): string {
    return document.getElementsByTagName('base')[0].href;
}

export const BASE_URL = new InjectionToken<string>('BASE_URL');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
            withViewTransitions()
        ),
        { provide: BASE_URL, useFactory: getBaseUrl, deps: [] },
        provideHttpClient(withInterceptors([AuthIntercept])),
        importProvidersFrom(HammerModule, SnackBarModule, ConfirmationDialogModule, MessageBoxDialogModule, QuillModule.forRoot()),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideNativeDateAdapter(),
        provideQuillConfig({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    ['blockquote'],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
                    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
                    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
                    [{ font: [] }, { align: [] }],
                    ['clean'],
                ],
            },
            theme: 'snow',
        }),
        provideAnimationsAsync(),
        {
            provide: PCPS_DIALOGS_DEFAULT_OPTIONS,
            useValue: {
                useClassicCancel: true,
            } as PCPSDialogsDefaultOptions,
        },
        {
            provide: PCPS_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: {
                invertBackground: true,
            } as PCPSSnackBarDefaultOptions,
        },
        SplashService,
    ],
};
